import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { GetNearbyAdventuresDocument } from 'hooks/useQueries'

type NearbyAdventuresSsr = {
  adventure?: unknown
}

// Seeds the "More Things To Do Nearby" slider so it renders from the SSR payload
// instead of fetching on scroll. The id must match the consumer exactly (the
// component queries { id: adventureId } where adventureId is the stringified
// route id). The payload is the query's `data` shape ({ adventure: … }).
// writeQuery is synchronous — safe in mini_racer SSR.
const seedNearbyAdventures = (
  client: ApolloClient<NormalizedCacheObject>,
  ssr: NearbyAdventuresSsr | undefined,
  adventureId: string | undefined,
): void => {
  if (!ssr?.adventure || adventureId == null) return

  try {
    client.writeQuery({
      query: GetNearbyAdventuresDocument,
      variables: { id: adventureId },
      data: ssr,
    })
  } catch {
    // Best-effort: a malformed payload must not break the render.
  }
}

export default seedNearbyAdventures
